@let localHome = home();
@let language = localHome?.home?.language;

<section class="home-download-app" id="aplicacion" aria-labelledby="download-app-title">
  <article class="home-download-app__card">
    <!-- TODO(api): reemplazar por la imagen del banner configurada desde el backend. -->
    <img
      class="home-download-app__image"
      [lazyLoad]="'img/home/featured-vr-llanos.png'"
      alt="Viajero disfrutando una experiencia inmersiva de Colombia"
    />
    <span class="home-download-app__shade" aria-hidden="true"></span>

    <div class="home-download-app__copy">
      <p>Vive experiencias inmersivas</p>
      <h2 id="download-app-title">
        {{ language?.banner_title || 'Realidad virtual y aumentada' }}
      </h2>
      <div class="home-download-app__description">
        {{
          language?.banner_subtitle ||
            'Descarga gratis nuestra app y explora Colombia como nunca antes.'
        }}
      </div>

      <div class="home-download-app__stores">
        @if (language?.banner_image_android) {
          <button
            type="button"
            aria-label="Descargar en Google Play"
            (click)="goToUrl(language?.banner_url_android)"
          >
            <img [lazyLoad]="language?.banner_image_android || ''" alt="Google Play" />
          </button>
        }
        @if (language?.banner_image_ios) {
          <button
            type="button"
            aria-label="Descargar en App Store"
            (click)="goToUrl(language?.banner_url_ios)"
          >
            <img [lazyLoad]="language?.banner_image_ios || ''" alt="App Store" />
          </button>
        }
      </div>
    </div>
  </article>
</section>
